import { inject, Injectable } from '@angular/core';
import { ConfirmationService } from '@openng/optimus-ui/api';

export interface UiConfirmOptions {
  header: string;
  message: string;
  acceptLabel: string;
  rejectLabel: string;
  /** PrimeIcons class of the mark beside the message. */
  icon?: string;
  /** Extra class on the accept button, e.g. `p-button-danger` for a delete. */
  acceptButtonStyleClass?: string;
}

/**
 * Asks a yes/no question and resolves `true` only when the user accepts.
 *
 * Labels arrive translated from the caller: this library has no Transloco
 * dependency, so it never invents copy of its own.
 */
@Injectable({ providedIn: 'root' })
export class UiConfirmService {
  private readonly confirmation = inject(ConfirmationService);

  confirm(options: UiConfirmOptions): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmation.confirm({
        header: options.header,
        message: options.message,
        icon: options.icon ?? 'pi pi-exclamation-triangle',
        acceptLabel: options.acceptLabel,
        rejectLabel: options.rejectLabel,
        acceptButtonStyleClass: options.acceptButtonStyleClass,
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
